import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { LoadingAnimation } from "../../../../components/Loading/LoadingAnimation";
import { Button } from "../../../../components";
import { AiOutlineCloudUpload } from "react-icons/ai";
import { handleSaveLeadCapturedNudge } from '../../../../helper/';
import { createLeadCapturedPersonaState } from "../../../../helper/customizedNudge/LeadCapturedPersonaNudge/LeadCapturedPersonaNudge";
import LeadCapturedPreview from "../../PreviewNudge/LeadCapturedPreview";
import NudgeFields from "../FirstTimePersonaNudge/NudgeFields";
import NudgeFieldsURL from "../FirstTimePersonaNudge/NudgeFieldsURL";
import NudgeOptions from "../FirstTimePersonaNudge/NudgeOptions";
import PersonaNudgeTitle from "../FirstTimePersonaNudge/PersonaNudgeTitle";
import ReferrerSites from "../FirstTimePersonaNudge/ReferrerSites/ReferrerSites";
import ToggleSwitch from "../FirstTimePersonaNudge/ToggleSwitch";
import UrlQueryParams from "../FirstTimePersonaNudge/UrlQueryParams/UrlQueryParams";
import LeadNudgeArea from './LeadNudgeArea';
import HtmlDesignEditor from "../HtmlDesignEditor";


const LeadCapturedPersonaNudge = (props) => {
  // console.log("props", props);
  let { nudgeData, nudgeId, isLoading, user, nudgeText, userPersonas,
    setUserPersonas, userPersonaKey, handleSaveUserPersonas } = props;
  const activeButton = useRef(null);
  const [nudgeFields, setNudgeFields] = useState({});
  const [customizeState, setCustomizeState] = useState({});
  const [nudgePosition, setNudgePosition] = useState({
    desktop: { top: 0, left: 0 },
    mobile: { top: 0 },
  });
  const [nudgeMode, setNudgeMode] = useState("desktop");

  const globalNudgeData = useSelector((state) => state.nudge.globalNudgeData) || {};
  const globalFields = globalNudgeData["leadCapturePersonaNudge"]

  useEffect(() => {
    if (nudgeData) {
      const state = createLeadCapturedPersonaState(nudgeData);
      setCustomizeState(state);
      console.log("state", state);

      if (state.useHtmlDesign) {
        activeButton.current = "htmlDesignCode";
        setNudgeFields({ optionValue: "htmlDesignCode", optionName: "Custom HTML Design" });
      } else {
        activeButton.current = nudgeData?.nudgeOfferText?.optionValue;
        setNudgeFields(nudgeData?.nudgeOfferText || {});
      }

      if (nudgeData?.nudge?.nudgePosition) {
        setNudgePosition((prev) => ({
          ...prev,
          desktop: {
            top: nudgeData.nudge.nudgePosition.desktop.top,
            left: nudgeData.nudge.nudgePosition.desktop.left,
          },
          mobile: { top: nudgeData.nudge.nudgePosition.mobile.top },
        }));
      }
    }
  }, [nudgeData]);

  const handleDesignSourceToggle = (useHtml) => {
    setCustomizeState((prev) => ({
      ...prev,
      useHtmlDesign: useHtml,
    }));
    if (useHtml) {
      const htmlOption = { optionValue: "htmlDesignCode", optionName: "Custom HTML Design" };
      setNudgeFields(htmlOption);
      activeButton.current = "htmlDesignCode";
    } else {
      activeButton.current = nudgeData?.nudgeOfferText?.optionValue;
      setNudgeFields(nudgeData?.nudgeOfferText || {});
    }
  };

  const handleNudgeOptionClick = (option) => {
    setNudgeFields(option);
    activeButton.current = option.optionValue;
  };
  const { optionName: nudgeTitle, optionValue: nudgeName } = nudgeText;


  return (
    <div className="persona__nudge border border-neutral-600 dark:border-neutral-800 rounded shadow-lg shadow-blue-800 w-full p-2 sm:p-4">
      {/* <UserSegment
                  customizeState={customizeState}
                  nudgeData={nudgeData}
      /> */}
      <div className="flex justify-around items-center mb-4">
        <PersonaNudgeTitle
          userPersonas={userPersonas}
          setUserPersonas={setUserPersonas}
          userPersonaKey={userPersonaKey}
        />
        <div className="absolute right-3 flex justify-center items-center gap-4">
          {customizeState?.hasCustomHtml && (
            <div className="flex bg-neutral-200 dark:bg-neutral-900 rounded p-1 border border-neutral-300 dark:border-neutral-700">
              <button
                onClick={() => handleDesignSourceToggle(false)}
                className={`px-3 py-1 rounded text-xs font-semibold transition-all ${
                  !customizeState.useHtmlDesign
                    ? "bg-blue-600 text-white shadow"
                    : "text-neutral-600 dark:text-neutral-400 hover:text-neutral-900 dark:hover:text-white"
                }`}
              >
                Dashboard Customization
              </button>
              <button
                onClick={() => handleDesignSourceToggle(true)}
                className={`px-3 py-1 rounded text-xs font-semibold transition-all ${
                  customizeState.useHtmlDesign
                    ? "bg-blue-600 text-white shadow"
                    : "text-neutral-600 dark:text-neutral-400 hover:text-neutral-900 dark:hover:text-white"
                }`}
              >
                Custom HTML Code
              </button>
            </div>
          )}
          <div className="flex justify-center items-center">
            <ToggleSwitch
              customizeState={customizeState}
              setCustomizeState={setCustomizeState}
              nudgeData={nudgeData}
            />
            <span className="mx-2">Activate</span>
          </div>
        </div>
      </div>

      <div className="optionContainer lg:flex py-8 ">
        <NudgeOptions
          nudgeData={nudgeData}
          activeButton={activeButton.current}
          handleNudgeOptionClick={handleNudgeOptionClick}
          userPersonaKey={userPersonaKey}
          customizeState={customizeState}
        />
        {activeButton.current === "htmlDesignCode" ? (
          <HtmlDesignEditor
            htmlDesignCode={customizeState.htmlDesignCode}
            onChange={(val) => {
              setCustomizeState(prev => ({
                ...prev,
                htmlDesignCode: val
              }));
            }}
            handleSave={() => {
              handleSaveLeadCapturedNudge(
                nudgeData,
                customizeState,
                nudgePosition,
                user,
                nudgeName
              );
              handleSaveUserPersonas();
            }}
          />
        ) : activeButton.current !== "nudgeShowing" ? (
          <NudgeFields
            nudgeFields={nudgeFields}
            globalFields={globalFields[activeButton.current]}
            setNudgeFields={setNudgeFields}
            customizeState={customizeState}
            handleSave={() => {
              handleSaveLeadCapturedNudge(
                nudgeData,
                customizeState,
                nudgePosition,
                user,
                nudgeName
              )
              handleSaveUserPersonas()
            }
            }
            setCustomizeState={setCustomizeState}
          />
        ) : (
          <NudgeFieldsURL
            nudgeFields={nudgeFields}
            globalFields={globalFields["nudgeShowing"]}
            setNudgeFields={setNudgeFields}
            customizeState={customizeState}
            handleSave={() => {
              handleSaveLeadCapturedNudge(
                nudgeData,
                customizeState,
                nudgePosition,
                user,
                nudgeName
              )
              handleSaveUserPersonas()
            }
            }
            setCustomizeState={setCustomizeState}
          />
        )}
      </div>
      <ReferrerSites
        referrerSitesData={[]}
        customizeState={customizeState}
        setCustomizeState={setCustomizeState}
        nudgeData={nudgeData}
      />
      <UrlQueryParams
        URLqueryParamData={[]}
        customizeState={customizeState}
        setCustomizeState={setCustomizeState}
        nudgeData={nudgeData}
      />
      <hr />
      <LeadCapturedPreview
        nudgeMode={nudgeMode}
        setNudgeMode={setNudgeMode}
        customizeState={customizeState}
        nudgePosition={nudgePosition}
        nudgeId={nudgeId}
        id="desktop"
        userPersonaKey={userPersonaKey}
      />
      {isLoading.loading ? (
        <LoadingAnimation />
      ) : (
        <LeadNudgeArea
          nudgeMode={nudgeMode}
          customizeState={customizeState}
          nudgeId={nudgeId}
          setNudgePosition={setNudgePosition}
          setCustomizeState={setCustomizeState}
          id="mobile"
        />
      )}
    </div>
  );
};

export default LeadCapturedPersonaNudge;
